import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  EditMapping,
  EditThirdparty,
  assignBulkOrders,
  assignOrders,
  cancelOrders,
  deleteMapping,
  deleteThirdparty,
  exportEvents,
  getEvents,
  getMapping,
  getMappingTypes,
  getOrders,
  getPaymentThirdparty,
  getPaymentsType,
  getThirdparty,
  getThirdpartyType,
  postMapping,
  postThirdParty,
  printOrders,
} from "../../services/ThirdParty/ThirdParty_services";

const initialValues = {
  mappingData: [],
  thirdpartyData: [],
  PaymentTypeList: [],
  thirdpartyPayments: [],
  thirdpartyCouriers: [],
};

let thirdPartyStore = (set) => ({
  ...initialValues,
  assignOrders: async (params) => {
    const response = await assignOrders(params);
    return response;
  },
    assignBulkOrders: async (params) => {
    const response = await assignBulkOrders(params);
    return response;
  },
  cancelOrders: async (params) => {
    const response = await cancelOrders(params);
    return response;
  },
  printOrders: async (params,params2) => {
    const response = await printOrders(params,params2);
    return response;
  },
  deleteThirdparty: async (params) => {
    const response = await deleteThirdparty(params);
    return response;
  },
  getPaymentThirdparty: async () => {
    const response = await getPaymentThirdparty();
    set({ thirdpartyPayments: response });
    return response;
  },
  deleteMapping: async (params) => {
    const response = await deleteMapping(params);
    return response;
  },
  getThirdparty: async (params) => {
    const response = await getThirdparty(params);
    set({ thirdpartyCouriers: response?.data?.data?.content });
    return response;
  },
  getMapping: async (params) => {
    const response = await getMapping(params);
    return response;
  },
  getMappingTypes: async (params) => {
    const response = await getMappingTypes(params);
    set({ mappingData: response?.data?.data });
    return response;
  },
  getThirdpartyType: async (params) => {
    const response = await getThirdpartyType(params);
    set({ thirdpartyData: response?.data?.data });
    return response;
  },
  getEvents: async (params) => {
    const response = await getEvents(params);
    return response;
  },
  exportEvents: async (params) => {
    const response = await exportEvents(params);
    return response;
  },
  getOrders: async (params) => {
    const response = await getOrders(params);
    return response;
  },
  postThirdParty: async (data) => {
    const response = await postThirdParty(data);
    return response;
  },
  postMapping: async (data) => {
    const response = await postMapping(data);
    return response;
  },
  EditThirdparty: async (params, data) => {
    const response = await EditThirdparty(params, data);
    return response;
  },
  EditMapping: async (params, data) => {
    const response = await EditMapping(params, data);
    return response;
  },
  getPaymentsType: async () => {
    const response = await getPaymentsType();
    set({ PaymentTypeList: response });
    return response;
  },
});

thirdPartyStore = devtools(thirdPartyStore);

export const useThirdPartyStore = create(thirdPartyStore);
